import * as React from 'react';
import './Navigation.scss';
import { UserService } from 'services/ApiService';
import { Redirect, NavLink } from 'react-router-dom';
import AlertIcon from '../../assets/AlertIcon';

import { IoPerson, IoDocumentText, IoIosPeople } from 'react-icons/lib/io';
import { MdStore } from 'react-icons/lib/md';

import { UserType } from 'types';
import { CHANNELS_PATH, STORES_PATH, ACCOUNTS_PATH, CLAIMS_PATH, PROFILE_PATH, ALERTS_PATH } from 'helpers/routes';

export default class Main extends React.Component<{}, {logout: boolean}> {
  constructor(props: {}) {
    super(props);
    this.state = {
      logout: false
    };
  }
  logout = () => {
    UserService.logout().then(success => {
      this.setState({logout: true});
    });
  }
  render() {
    return this.state.logout ? <Redirect to="/" /> : (
      <nav className="nav">
        <div className="links">
          <NavLink to={CLAIMS_PATH} exact={true} activeClassName="active">
            <span><IoDocumentText className="nav-icon" /></span>
            Claims
          </NavLink>
          {
            UserService.getType() === UserType.QAAdmin ||
              UserService.getType() === UserType.Admin ?
              (
                <>
                  <NavLink to={ALERTS_PATH} activeClassName="active">
                    <span>
                      <AlertIcon className="nav-icon" />
                    </span>
                    Alerts
                  </NavLink>
                  <NavLink to={ACCOUNTS_PATH} activeClassName="active">
                    <span><IoIosPeople className="nav-icon" /></span>
                    Accounts
                  </NavLink>
                </>
              )
              : null
          }          
          <NavLink to={PROFILE_PATH} activeClassName="active">
            <span><IoPerson className="nav-icon" /></span>
            Profile
          </NavLink>
          {
            UserService.getType() === UserType.Admin ? <>
            
            <NavLink to={STORES_PATH} activeClassName="active">
              <span><MdStore className="nav-icon"/></span>
              Stores
            </NavLink> </> :
            null
          }
          {
            UserService.getType() === UserType.LCBOReporter ? <>
            <NavLink to={CHANNELS_PATH} activeClassName="active">
              <span><MdStore className="nav-icon" /></span>
              Channels
            </NavLink> </> :
            null
          }
        </div>
        <button className="logout" onClick={this.logout}>Log Out</button>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Navigation/index.tsx